'use client';

import * as React from 'react';
import { useAuth } from '../services/auth-service';

/**
 * RefreshUserButton component that allows users to manually refresh their
 * role and permissions from WorkOS without requiring re-authentication.
 * This is useful when user roles have been changed in the admin interface.
 */
export const RefreshUserButton = () => {
  const { refreshTokens, user } = useAuth();
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await refreshTokens();
      location.reload();
    } finally {
      setIsRefreshing(false);
    }
  };

  // Only show for authenticated users
  if (!user) {
    return null;
  }

  return (
    <button
      onClick={handleRefresh}
      disabled={isRefreshing}
      className="inline-flex items-center px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground border border-border rounded-md hover:bg-accent/50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      {isRefreshing ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2"></div>
          Refreshing...
        </>
      ) : (
        <>
          <svg
            className="w-4 h-4 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          Refresh
        </>
      )}
    </button>
  );
};

RefreshUserButton.displayName = 'RefreshUserButton';
